module.exports = __webpack_public_path__ + "static/img/北京农村商业银行.ec189b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/北京农村商业银行.png
// module id = /Q49
// module chunks = 18